import InstitutionDetails from "../models/Institution/InstitutionDetails";
import Request from "../models/Request/Request";

export const mapInstitutionDetailsToRequest = (
  request: Request,
  institutionDetails: InstitutionDetails
): Request => {
  const {
    id: institutionId,
    mandatoryForeignLanguages,
    electiveSubjects,
    languageSchoolingModels,
    foreignLanguages,
  } = institutionDetails;

  return {
    ...request,
    institutionId,
    mandatoryForeignLanguages,
    electiveSubjects,
    languageSchoolingModels,
    foreignLanguages,
    institutionProgram: undefined,
    institutionProgramId: undefined,
  };
};
